import { useState, useEffect } from "react";

export default function JaNej() {
    const [text, setText] = useState("");
    const [color, setColor] = useState("");

    function updateText() {
        const now = new Date();
        const options = { timeZone: "Europe/Stockholm", hour: "numeric", hourCycle: "h23" };
        const hour = new Intl.DateTimeFormat("en-US", options).format(now);
        const isJaTime = (hour >= 11 || hour < 3);
        
        setText(isJaTime ? "JA" : "NEJ");
        setColor(isJaTime ? "green" : "red");
    }

    useEffect(() => {
        updateText();
        const interval = setInterval(updateText, 60000);
        return () => clearInterval(interval);
    }, []);

    return (
        <div className="flex justify-center items-center h-screen bg-gray-100">
            <div className="flex flex-col items-center">
                <div className="text-9xl font-bold p-5" style={{ color }}>{text}</div>
                <a 
                    href="https://www.regeringen.se/contentassets/fde9c03b4ccd4ca7a41da4cc1199950e/del-2-kap.-4-8" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="text-lg mt-4 text-blue-600 hover:text-blue-800"
                >
                    Med vänliga hälsningar, Regeringen
                </a>
            </div>
        </div>
    );
}
